import { useEffect, useState } from "react";

interface ProgressIndicatorProps {
  used: number;
  total: number;
  className?: string;
  barWidth?: string;
  color?: string;
}

const ProgressIndicator = ({
  used,
  total,
  className = "",
  barWidth,
  color,
}: ProgressIndicatorProps) => {
  const [width, setWidth] = useState(0);
  const percentage = Math.round((used / total) * 100);

  useEffect(() => {
    setWidth(0);
    const timer = setTimeout(() => setWidth(percentage), 50);
    return () => clearTimeout(timer);
  }, [used, total, percentage]);

  return (
    <div className={`w-full ${className} flex items-center gap-4`}>
      <div
        className={`h-2 bg-gray-200 rounded-full overflow-hidden ${
          barWidth ? `w-${barWidth}` : "w-[147px]"
        }`}
      >
        <div
          className="h-full bg-[#17457D] transition-all duration-500 ease-out rounded-full"
          style={{ width: `${width}%` }}
        />
      </div>
      <div
        className={`text-sm font-medium ${
          color ? `text-${color}` : "text-gray-600"
        }`}
      >
        {percentage}%
      </div>
    </div>
  );
};

export default ProgressIndicator;
